<template>
  <div
    :class="['wt-to-general-grid-container', story.aspectRatio.name]"
    v-if="showGeneralGrid"
  >
    <div>
      <!--keep this div to centralize things -->
      <div class="general-grid-ruler wt-general-grid-ruler-horizontal">
        <ul class="wt-general-grid-ruler-scale">
          <li v-for="(n, index) in generalGridCubes.horizontal" :key="index">
            <span
              v-show="
                hideFirstAndLastRulerText(index, generalGridCubes.horizontal)
              "
              >{{ index }}</span
            >
          </li>
        </ul>
      </div>
      <div class="general-grid-ruler wt-general-grid-ruler-verical">
        <ul class="wt-general-grid-ruler-scale">
          <li v-for="(n, index) in generalGridCubes.vertical" :key="index">
            <span
              v-show="
                hideFirstAndLastRulerText(index, generalGridCubes.vertical)
              "
              >{{ index }}</span
            >
          </li>
        </ul>
      </div>
      <div class="to-general-grid" :class="[story.aspectRatio.name]">
        <div class="wt-general-grid-lines wt-general-grid-horizontal-lines">
          <div
            v-for="(n, i) in this.generalGridCubes.horizontal"
            :key="i"
            class="wt-general-grid-line wt-to-snap"
          ></div>
        </div>
        <div class="wt-general-grid-lines wt-general-grid-vertical-lines">
          <div
            v-for="(n, i) in this.generalGridCubes.vertical"
            :key="i"
            class="wt-general-grid-line wt-to-snap"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Asset Editor's text overlay general grid Vue
 */
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('assetEditor', ['pageTmpState', 'story']),

    showGeneralGrid: function () {
      return !!this.pageTmpState.showGeneralGrid;
    },

    generalGridCubes: function () {
      const vertical = 14;
      let horizontal = 21; // 16/9 / default

      switch (this.story.aspectRatio.name) {
        case 'ASPECT_4_5':
          horizontal = 10;
          break;
        case 'ASPECT_1_1':
          horizontal = 12;
          break;
        case 'ASPECT_9_16':
          horizontal = 7;
          break;
        case 'ASPECT_3_4':
          horizontal = 5;
          break;
        case 'ASPECT_3_2':
          horizontal = 5;
          break;
      }

      return {
        horizontal,
        vertical,
      };
    },
  },

  methods: {
    isFirst: function (index) {
      return index === 0;
    },

    isLast: function (index, curIndex) {
      return index + 1 === curIndex;
    },

    hideFirstAndLastRulerText: function (index, curIndex) {
      return !this.isFirst(index) && !this.isLast(index, curIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'asset_editor/_variables.scss';
.wt-to-general-grid-container {
  height: $asset-height;
  width: $asset-width;
  position: absolute;
  z-index: $stage-zindex + 9;
  top: 0;
  left: 0;
  pointer-events: none;

  & > div {
    height: 100%;
    position: relative;
    margin: 0 auto;
  }

  &.ASPECT_4_5 {
    & > div {
      width: calc(
        #{$asset-width} - (#{$asset-width} - (#{$asset-height} * (4 / 5)))
      );
    }
  }

  &.ASPECT_3_4 {
    & > div {
      width: calc(
        #{$asset-width} - (#{$asset-width} - (#{$asset-height} * (3 / 4)))
      );
    }
  }

  &.ASPECT_3_2 {
    & > div {
      width: calc(
        #{$asset-width} - (#{$asset-width} - (#{$asset-height} * (3 / 2)))
      );
    }
  }

  &.ASPECT_1_1 {
    & > div {
      width: calc(#{$asset-width} - (#{$asset-width} - #{$asset-height}));
    }
  }

  &.ASPECT_9_16 {
    & > div {
      width: calc(
        #{$asset-width} - (#{$asset-width} - (#{$asset-height} * (9 / 16)))
      );
    }
  }

  .general-grid-ruler {
    position: absolute;
    pointer-events: none;

    &.wt-general-grid-ruler-verical {
      left: -35px;
      top: 0;
      transform-origin: 0 0;
      width: 35px;
      padding-right: 1px;
      height: $asset-height;
      border-color: $general-grid-color;
      border-style: none solid none none;
      border-width: 3px;

      .wt-general-grid-ruler-scale {
        height: $asset-height;
        position: absolute;
        flex-direction: column;

        li {
          height: calc(#{$asset-height} / 14);
          flex: 1;
          width: 30px;
          line-height: 0;
          text-align: right;
          padding-right: 10px;
          position: relative;
          color: $general-grid-color;
          span {
            position: absolute;
            right: 8px;
            top: 0;
          }

          &:after {
            content: ' ';
            position: absolute;
            top: 0;
            right: -2px;
            height: 1px;
            border-bottom: 1px solid $general-grid-color;
            width: 5px;
            z-index: 2;
          }
          &:last-child {
            position: absolute;
            right: 0;
            bottom: 0;
            transform: translate(0, 100%);
          }
        }
      }
    }

    &.wt-general-grid-ruler-horizontal {
      left: 0;
      top: -28px;
      transform-origin: 0 0;
      width: 100%;
      height: 25px;
      display: flex;
      justify-content: center;
      border-color: $general-grid-color;
      border-style: none none solid none;
      border-width: 3px;
      box-sizing: content-box;

      .wt-general-grid-ruler-scale {
        width: 100%;
        height: 15px;
        margin-top: 10px;
        position: relative;
        flex-direction: row;

        li {
          width: calc(100% / 21);
          line-height: 0;
          text-align: left;
          position: relative;
          float: left;
          height: 14px;

          span {
            position: absolute;
            left: -3px;
            top: 3px;
          }
          &:after {
            content: ' ';
            position: absolute;
            left: 0;
            background: $general-grid-color;
            height: 7px;
            width: 1px;
            bottom: -4px;
            z-index: 2;
          }
          &:last-child {
            position: absolute;
            right: 0;
            top: 0;
            width: 1px;
          }
        }
      }
    }

    .wt-general-grid-ruler-scale {
      list-style-type: none;
      left: 0;
      top: 0;
      margin: 0;
      padding: 0;
      white-space: nowrap;
      color: $general-grid-color;
      overflow: visible;
      font-size: 11px;
      display: flex;
      li {
        flex: 1;
      }
    }
  }

  #to-general-grid-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: $stage-zindex + 4;
    pointer-events: none;
  }

  .to-general-grid {
    margin: 0 auto;
    height: 100%;
    position: relative;
    width: 100%;

    .wt-general-grid-lines {
      display: flex;
      height: 100%;
      width: 100%;

      &.wt-general-grid-vertical-lines {
        position: absolute;
        top: 0;
        left: 0;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: space-between;

        .wt-general-grid-line {
          width: 100%;
          border: 0;
          position: relative;
          &:after {
            content: ' ';
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            height: 1px;
            border-bottom: 1px solid rgba(204, 204, 204, 0.7);
          }
        }
      }
      &.wt-general-grid-horizontal-lines {
        position: absolute;
        top: 0;
        left: 0;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;

        .wt-general-grid-line {
          width: 1px;
          height: 100%;
          border: 0;
          position: relative;
          &:after {
            content: ' ';
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            width: 1px;
            border-right: 1px solid rgba(204, 204, 204, 0.7);
          }
        }
      }
    }
  }
}
</style>
